import Banner from "@/components/landing/homeNine/Banner";
import Benefits from "@/components/landing/homeNine/Benefits";
import CallToAction from "@/components/landing/homeNine/CallToAction";
import Faqs from "@/components/landing/homeNine/Faqs";
import GetStarted from "@/components/landing/homeNine/GetStarted";
import PricingPlan from "@/components/landing/homeNine/PricingPlan";
import freelancerEarningsFaqs from "@/data/faqFreelancerEarnings";

export default function HomeNine() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Benefits section */}
      <Benefits />

      {/* Call To Action section */}
      <CallToAction />

      {/* Pricing Plan section */}
      <PricingPlan />

      {/* Get Started section */}
      <GetStarted />

      {/* Faqs section */}
      <Faqs
        sectionTitle="Earnings & reporting FAQs"
        sectionDescription="How OracleMarket helps you understand income, fees, and exports in one place."
        faqs={freelancerEarningsFaqs}
      />
    </>
  );
}
